import React, { Component } from 'react';

export default class Privacy extends Component {
    render() {
        return (
            <div className="privacy-page">
                <h1>PRIVACY AND POLICY</h1>
            </div>
        );
    }
}
